import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricStorageGetStorageSyncApi = <T extends Json>(key: string) => T;

/**
 * 同步接口, 从本地缓存中异步获取指定 key 的内容
 * @param key
 * @returns Promise<T extends Json>
 */
export const getStorageSync: FabricStorageGetStorageSyncApi = <T extends Json>(
  key: string
) => {
  const result = core.call<'fabric_storage.getStorageSync', string, string>(
    'fabric_storage.getStorageSync',
    key
  );
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return JSON.parse(result.data) as T;
  }
};
